import { useQuery } from '@tanstack/react-query';
import { authorizeMicrosoft } from 'api/services';
import { BrokenLinkIcon } from 'library/icons';
import { CircularProgress } from 'library/loaders';
import { IllustrationView } from 'modules/shared/features/illustration';
import { Link, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const constructMicrosoftRedirectUrl = () => {
    return window.location.origin + '/microsoft-authorization';
};

const MicrosoftIllustration = () => {
    return (
        <div className="flex items-center gap-5">
            <img className="h-10" src="/logos/logo.png" alt="progressCenter" />
            <BrokenLinkIcon />
            <img className="h-10" src="/plugins-images/microsoft.svg" alt="Microsoft" />
        </div>
    );
};

const MicrosoftAuthorizationPage = () => {
    const [searchParams] = useSearchParams();

    const code = searchParams.get('code');
    const state = searchParams.get('state');

    const redirectUri = constructMicrosoftRedirectUrl();

    const { pluginId, url } = JSON.parse(decodeURIComponent(state));

    const microsoftQuery = useQuery(
        ['microsoft-authenticate', code, redirectUri],
        () => authorizeMicrosoft({ code, redirectUri }),
        {
            retry: 0,
        }
    );

    if (microsoftQuery.isSuccess) {
        toast.success('Microsoft account linked successfully.');

        window.location.replace(`${url}/plugins/${pluginId}/microsoft`);
    }

    if (microsoftQuery.isLoading) {
        return (
            <section>
                <div className="fixed top-0 left-0 flex flex-col items-center justify-center h-screen w-full bg-card-color">
                    <div className="flex items-center justify-center w-14 h-14 rounded-lg text-primary ">
                        <CircularProgress size={32} />
                    </div>
                </div>
            </section>
        );
    }

    if (microsoftQuery.error) {
        return (
            <IllustrationView
                className="justify-center h-screen"
                illustration={<MicrosoftIllustration />}
                title="Microsoft Authorization Failed"
                message={
                    <>
                        {/* We couldn’t connect to your Microsoft account. Please check your credentials or try again. */}
                        {(microsoftQuery.error as any).data.message}
                        <div className="mt-2">
                            <Link to={`${url}`} replace className="text-primary font-medium cursor-pointer">
                                Back to home
                            </Link>
                        </div>
                    </>
                }
            />
        );
    }
};

export default MicrosoftAuthorizationPage;
